export default __webpack_public_path__ + "static/media/open-positions-tablet.f73b8d85.jpg";